"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _index = require("./index");

var _ListItem = _interopRequireDefault(require("@material-ui/core/ListItem"));

var _ListItemSecondaryAction = _interopRequireDefault(require("@material-ui/core/ListItemSecondaryAction"));

var _ListItemText = _interopRequireDefault(require("@material-ui/core/ListItemText"));

var _Typography = _interopRequireDefault(require("@eig-builder/core-ui/Typography"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  /* these are very specific therefore no spacing */\n  min-height: 35px !important;\n  padding-top: 4px !important;\n  padding-bottom: 4px !important;\n\n  :hover {\n    background: ", ";\n    cursor: pointer;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var StyledListItem = (0, _styledComponents["default"])(_ListItem["default"])(_templateObject(), function (props) {
  return props.theme.palette.black.lightest;
});

var ComboBoxItem = function ComboBoxItem(_ref) {
  var children = _ref.children,
      value = _ref.value,
      amount = _ref.amount;
  var context = (0, _index.useComboBoxContext)();
  var componentIsSelected = context.checkForSelectedItem(value);
  return /*#__PURE__*/_react["default"].createElement(StyledListItem, {
    onClick: function onClick() {
      return context.selectItem(value);
    },
    selected: componentIsSelected
  }, /*#__PURE__*/_react["default"].createElement(_ListItemText["default"], null, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    variant: "body2"
  }, children)), /*#__PURE__*/_react["default"].createElement(_ListItemSecondaryAction["default"], null, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    variant: "body2",
    color: "textSecondary"
  }, amount)));
};

ComboBoxItem.propTypes = {
  children: _propTypes["default"].node.isRequired,
  value: _propTypes["default"].any.isRequired,
  amount: _propTypes["default"].number.isRequired
};
var _default = ComboBoxItem;
exports["default"] = _default;